import { Controller } from "@hotwired/stimulus"

// Minimal modal controller for the billing offer dialogs: closes on backdrop
// click, ESC, or the close/cancel buttons by removing the injected modal.
export default class extends Controller {
  connect() {
    this.boundKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
  }

  handleKeydown(event) {
    // An open dropdown inside the modal (the SlimSelect recipient pickers) consumes its own
    // Escape and cancels the event — that keystroke closes the dropdown, not the modal.
    if (event.key === "Escape" && !event.defaultPrevented) this.close()
  }

  close() {
    this.element.remove()
  }
}
